(() => {
  if (!customElements.get("countdown-timer")) {
    customElements.define(
      "countdown-timer",
      class CountdownTimer extends HTMLElement {
        selectors = {
          time: "time",
          days: "[data-days]",
          hours: "[data-hours]",
          minutes: "[data-minutes]",
          seconds: "[data-seconds]",
        };
        classes = {
          hidden: "hidden",
        };

        constructor() {
          super();

          this.timeElement = this.querySelector(this.selectors.time);
          this.daysElement = this.querySelector(this.selectors.days);
          this.hoursElement = this.querySelector(this.selectors.hours);
          this.minutesElement = this.querySelector(this.selectors.minutes);
          this.secondsElement = this.querySelector(this.selectors.seconds);
          this.endDate = Date.parse(this.timeElement.dateTime);

          this.millisecondsInDay = 864e5; // 24 * 60 * 60 * 1000
          this.millisecondsInHour = this.millisecondsInDay / 24;
          this.millisecondsInMinute = this.millisecondsInHour / 60;
          this.millisecondsInSecond = this.millisecondsInMinute / 60;

          this.update = this.update.bind(this);
        }

        connectedCallback() {
          if (isNaN(this.endDate) || this.endDate <= Date.now()) {
            this.onComplete();
          } else {
            this.update();
            this.interval = setInterval(this.update, 1000);
          }
        }

        disconnectedCallback() {
          this.stopTimer();
        }

        convertTime(remainingMs) {
          const days = this.formatDigits(
            parseInt(remainingMs / this.millisecondsInDay, 10)
          );
          remainingMs -= days * this.millisecondsInDay;

          const hours = this.formatDigits(
            parseInt(remainingMs / this.millisecondsInHour, 10)
          );
          remainingMs -= hours * this.millisecondsInHour;

          const minutes = this.formatDigits(
            parseInt(remainingMs / this.millisecondsInMinute, 10)
          );
          remainingMs -= minutes * this.millisecondsInMinute;

          const seconds = this.formatDigits(
            parseInt(remainingMs / this.millisecondsInSecond, 10)
          );

          return {
            days,
            hours,
            minutes,
            seconds,
          };
        }

        formatDigits(value) {
          if (value < 10) {
            value = "0" + value;
          }
          return value;
        }

        render(timeParts) {
          this.daysElement.textContent = timeParts.days;
          this.hoursElement.textContent = timeParts.hours;
          this.minutesElement.textContent = timeParts.minutes;
          this.secondsElement.textContent = timeParts.seconds;
        }

        stopTimer() {
          clearInterval(this.interval);
        }

        onComplete() {
          this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          this.classList.add(this.classes.hidden);
        }

        update() {
          const nowMs = new Date().getTime();
          const remainingMs = this.endDate - nowMs;

          if (remainingMs < 1000) {
            this.stopTimer();
            this.onComplete();
            return;
          }

          const timeParts = this.convertTime(remainingMs);
          this.render(timeParts);
        }
      }
    );
  }
})();
